import { useState } from "react";
import { GetEventInputValue, ValidateFormView } from "../form/core";
import { FormInput } from "../form/input";
import { PasswordInput } from "../form/password-input";
import { CurrentUserStorage } from "../../library/core/current-user";
import { PrimaryButton } from "../form/primary-button";
import { SecondaryButton } from "../form/secondary-button";
import { InvalidInputMessage } from "../form/invalid-input";
const formView = {
  fields: [
    {
      name: "username",
      label: "Email address",
      type: "email",
      required: true,
    },
  ],
};

const LoginForm = ({
  keepMeLoggedIn,
  username,
  signinHandler,
  onForgotPassword,
  errorMessage,
}) => {
  const [model, setModel] = useState({
    keepMeLoggedIn,
    username: username || CurrentUserStorage.getCurrentUser(),
  });
  const [modelErrors, setModelErrors] = useState({});
  const [formState, setFormState] = useState({
    isLoading: false,
  });

  const onSubmitHandler = (event) => {
    event.preventDefault();
    const errs = ValidateFormView({ fields: formView.fields, model });
    setModelErrors(errs);

    if (!errs || Object.keys(errs).length === 0) {
      signinHandler && signinHandler(model);
    }
  };

  const onForgotPasswordhandler = (event) => {
    event.preventDefault();

    onForgotPassword && onForgotPassword();
  };

  const onFieldChangeHandler = (event) => {
    setModel({
      ...model,
      [event.target.name]: GetEventInputValue(event),
    });
  };

  return (
    <form className="w-full">
      <h1 className="text-center font-headings-primary font-medium text-[28px] leading-[33.6px] mb-4">
        Login to Vendor Portal
      </h1>

      {formView.fields.map((field) => (
        <FormInput
          key={field.name}
          dataModel={model}
          {...field}
          errorsModel={modelErrors}
          onChange={onFieldChangeHandler}
        />
      ))}
      <PasswordInput
        name="password"
        value={model.password}
        onChange={onFieldChangeHandler}
        error={modelErrors?.password}
      />
      <div className="mb-3">
        <InvalidInputMessage errorMessage={errorMessage} />
      </div>

      <PrimaryButton onClick={onSubmitHandler} loading={formState.isLoading}>
        Log in
      </PrimaryButton>

      <SecondaryButton
        onClick={onForgotPasswordhandler}
        className="mt-3 !border-black hover:!text-[#34353F]"
      >
        Reset password
      </SecondaryButton>

      <a
        href="https://bestgiftgroup.com/vendor-support/"
        target="_blank"
        rel="noreferrer"
      >
        <span className=" mt-3 !border-black w-full h-[50px] rounded-[16px]  text-white hover:!text-[#34353F] border font-headings-primary font-medium text-[18px] leading-6 disabled:opacity-60 active:scale-[.99] transition-colors flex items-center justify-center gap-2 ">
            Vendor support
        </span>
      </a>
    </form>
  );
};

export { LoginForm };
